var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrow1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 13,
    viewBox: "0 0 102 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9 6.29999L3.9 9.5L0 12.6V6.29999V0L3.9 3.20001L7.9 6.29999Z",
    fill: "#FFDD89"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2008 6.29999L27.2008 9.5L23.3008 12.6V6.29999V0L27.2008 3.20001L31.2008 6.29999Z",
    fill: "#FFDD89"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4996 6.29999L50.5996 9.5L46.5996 12.6V6.29999V0L50.5996 3.20001L54.4996 6.29999Z",
    fill: "#FFDD89"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8004 6.29999L73.9004 9.5L69.9004 12.6V6.29999V0L73.9004 3.20001L77.8004 6.29999Z",
    fill: "#FFDD89"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M101.199 6.29999L97.1992 9.5L93.1992 12.6V6.29999V0L97.1992 3.20001L101.199 6.29999Z",
    fill: "#FFDD89"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow1);
export default __webpack_public_path__ + "static/media/arrow-1.815fdd8dd51894452d45df4672e7717f.svg";
export { ForwardRef as ReactComponent };